export default __webpack_public_path__ + "static/media/blog-xl-4.673d56e8.png";